import React, { Component } from 'react'
import { Modal, FormGroup, ControlLabel, Row, Col} from 'react-bootstrap'
import Validation from 'react-validation'

import '../../felles/valideringsRegler'

export default class InfoFraKundeModal extends Component {

    constructor(props) {
        super(props)
        this.state = {
            infotekst:this.props.kommentar ?  this.props.kommentar : ''
        }

        this._submit = this._submit.bind(this)
        this._handleTekstEndret = this._handleTekstEndret.bind(this)
    }

    componentDidMount() {

    }

    _submit = (event) => {
        event.preventDefault()              
        this.props.onLeggTilInfo(this.state.infotekst)
    }

    _handleTekstEndret(data) {
        this.setState({
            infotekst: data.target.value
        });
    }

    render() {
        return (
            <Modal show={this.props.isOpen} onHide={this.props.onClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Info fra kunde</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                     <Validation.components.Form ref={c => this.form = c} onSubmit={this._submit}>
                        <Row>
                            <Col sm={12} >
                                <FormGroup>
                                    <ControlLabel>Info</ControlLabel>                                                                   
                                      <Validation.components.Textarea
                                        errorClassName='is-invalid-input'
                                        cols="40" rows="2"
                                        validations={['required','mindreEnn100Tegn']}
                                        value={this.state.infotekst}
                                        placeholder="Skriv inn info fra kunde"
                                        onChange={this._handleTekstEndret}
                                        className="form-control"
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                         
                         <Validation.components.Button className="btn btn-primary" >OK</Validation.components.Button>

                    </Validation.components.Form>
                </Modal.Body>
            </Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./src/planlegging/arbeidsliste/infofraKundeModal.jsx